import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'underscore'
import { useSetCurrentRoute } from '../../../hooks/getReduxData/useCurrentRoute'
import { setOpenPaymentModal } from '../../../redux/slices/modal'
import {
  calcTotalPrice,
  qrSelector,
  setCurrentRoute,
  setFromStopId,
  setQrAmount,
  setRouteId,
  setToStopId,
} from '../../../redux/slices/qr'
import { selectSelector } from '../../../redux/slices/select'
import { fetchQrCart, fetchRoutePrice } from '../../../redux/thunks/qr'
import { fetchRoutesStops } from '../../../redux/thunks/select'
import ButtonBuy from '../../reusable/Buttons/ButtonBuy'
import Hdivider from '../../reusable/Dividers/Hdivider'
import Counter from '../../reusable/Fields/Counter'
import SelectField from '../../reusable/Fields/SelectField'
import InfoIconBlockNoRoutes from '../../reusable/Info/Blocks/InfoIconBlockNoRoutes'
import InfoIconBlock from '../../reusable/Info/InfoIconBlock'
import KeyValueInfo from '../../reusable/Info/KeyValueInfo'
// import BuyQrTyModal from '../../reusable/Modals/InfoModals/BuyQrTyModal'
import PaymentModal from '../../reusable/Modals/PaymentModal'
import TransportSwitcher from '../../reusable/Switchers/TransportSwitcher/TransportSwitcher'

const BuyQrBlock = () => {
  const {
    route_id,
    qrAmount,
    from_stop_id,
    to_stop_id,
    routePrice: { price },
    totalPrice,
  } = useSelector(qrSelector)
  const btnBuyDisabled = !route_id || !from_stop_id || !to_stop_id || qrAmount < 1
  // const btnBuyDisabled = false
  const btnMinusDisabled = qrAmount <= 1
  const btnPlusDisabled = false // qrAmount >= 50 ?
  const { routes, routesStops, currentTransport, loading } = useSelector(selectSelector)
  const dispatch = useDispatch()
  useSetCurrentRoute(route_id, setCurrentRoute)

  useEffect(() => {
    dispatch(fetchRoutesStops({ route_id }))
  }, [dispatch, route_id])

  useEffect(() => {
    if (!route_id || !from_stop_id || !to_stop_id) return
    dispatch(fetchRoutePrice())
  }, [dispatch, route_id, from_stop_id, to_stop_id])

  useEffect(() => {
    dispatch(calcTotalPrice())
  }, [dispatch, price, qrAmount])

  const handleMinus = () => {
    dispatch(setQrAmount(qrAmount - 1))
  }
  const handlePlus = () => {
    dispatch(setQrAmount(qrAmount + 1))
  }

  const handleBuy = () => {
    dispatch(fetchQrCart())
      .unwrap()
      .then((originalPromiseResult) => {
        // console.log(originalPromiseResult)
        dispatch(setOpenPaymentModal(true))
      })
      .catch((rejectedValueOrSerializedError) => {
        // toast.error(rejectedValueOrSerializedError?.message)
      })
  }

  return (
    <div className="buy_block">
      <div className="qr_main">
        <div className="qr_params">
          <div className="transport_wrapper">
            <TransportSwitcher noTitles />
          </div>
          <SelectField
            standalone
            name="route_id"
            label="Маршрут"
            placeholder="Оберіть Маршрут"
            value={route_id}
            setter={setRouteId}
            options={routes}
            optionsKeys={{ valueKey: 'route_id', labelKey: 'number' }}
          />
          <SelectField
            standalone
            name="from_stop_id"
            label="Зупинка посадки"
            placeholder="Оберіть зупинку"
            value={from_stop_id}
            setter={setFromStopId}
            options={routesStops.filter((rs) => rs.stop_id !== to_stop_id)}
            optionsKeys={{ valueKey: 'stop_id', labelKey: 'name_uk' }}
          />
          <SelectField
            standalone
            name="to_stop_id"
            label="Зупинка виходу"
            placeholder="Оберіть зупинку"
            value={to_stop_id}
            setter={setToStopId}
            options={routesStops.filter((rs) => rs.stop_id !== from_stop_id)}
            optionsKeys={{ valueKey: 'stop_id', labelKey: 'name_uk' }}
          />
          <Counter
            title="Кількість квитків"
            value={qrAmount}
            handleMinus={handleMinus}
            handlePlus={handlePlus}
            btnMinusDisabled={btnMinusDisabled}
            btnPlusDisabled={btnPlusDisabled}
          />
        </div>
        {currentTransport?.id && !loading && routes?.length === 0 ? ( // fixed blink of InfoIconBlock
          <InfoIconBlockNoRoutes />
        ) : (
          <Hdivider />
        )}
        <div className="qr_info">
          <KeyValueInfo infoKey="Ви обрали" infoValue={qrAmount + ' квитків'} />
          {_.isNumber(price) && (
            <KeyValueInfo infoKey="Вартість 1 квитка" infoValue={price + ' UAH'} />
          )}

          <div className="to_pay">
            <KeyValueInfo infoKey="До сплати" infoValue={totalPrice + ' UAH'} big blueValue />
            <ButtonBuy handler={handleBuy} disabled={btnBuyDisabled} />
            <PaymentModal subtitle="Оберіть платіжну систему" />
            {/* <BuyQrTyModal /> */}
          </div>
        </div>
      </div>

      <InfoIconBlock
        info_msg="QR-квиток є дійсним протягом 15 днів з моменту його придбання."
        withBg
      />
    </div>
  )
}

export default BuyQrBlock
